export default "__VITE_ASSET__DVzS_1q2__"